import { createClient } from "@sanity/client";

export const client = createClient({
  projectId: "47i27g55",
  dataset: "production",
  apiVersion: "2024-01-01",
  useCdn: false,
});